import { FaFileContract } from "react-icons/fa";
import { defineType } from "sanity";
import termsAndConditionsSection from "../objects/termsAndConditionsSection";

export default defineType({
  name: "offersTermsAndConditions",
  title: "Offers Terms and Conditions Page",
  icon: FaFileContract,
  type: "document",
  groups: [
    {
      name: "seo",
      title: "SEO, Routing & Tracking"
    }
  ],
  fields: [
    {
      name: "heading",
      title: "Heading",
      type: "openingText"
    },
    {
      name: "sections",
      title: "Sections",
      type: "array",
      of: [{ type: termsAndConditionsSection.name }]
    },
    {
      name: "metadata",
      title: "SEO, Routing & Tracking",
      type: "metadata",
      group: "seo"
    }
  ],
  preview: {
    prepare(value) {
      return {
        title: "Terms and Conditions Page"
      };
    }
  }
});
